import * as React from "react";
import { isRequestActive } from "redux-request-loading";

import { Container, Table, Loader, Button } from "semantic-ui-react";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { loadDataExtracts } from "../actions";
import { LOAD_DATA_EXTRACTS } from "../actionTypes";
import { ApplicationState } from "../../applicationState";
import { DataExtractStatus } from "../models";

import { Link } from "redux-little-router";

export const All = () => {
    const dispatch = useDispatch();
    const loadingDataExtracts = useSelector((state: ApplicationState) => isRequestActive(state, LOAD_DATA_EXTRACTS));
    const dataExtracts = useSelector((state: ApplicationState) => state.dataExtracts);
    React.useEffect(() => {
        if (loadingDataExtracts !== true && !dataExtracts?.length) {
            dispatch(loadDataExtracts());
        }
    }, [dataExtracts?.length, dispatch, loadingDataExtracts]);
    if (loadingDataExtracts) {
        return <Loader active />;
    }

    return (
        <Container>
            <h1>Data Downloads</h1>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Customer Name</Table.HeaderCell>
                        <Table.HeaderCell>Employee Name</Table.HeaderCell>
                        <Table.HeaderCell>Date/Time of Export</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {dataExtracts && dataExtracts.sort((a, b) => -a.dateCreated.diff(b.dateCreated)).map(dataExtract => (
                        <Table.Row key={dataExtract.id}>
                            <Table.Cell>
                                {dataExtract.customer.name}
                            </Table.Cell>
                            <Table.Cell>
                                {dataExtract.employeeRecord && dataExtract.employeeRecord.name}
                            </Table.Cell>
                            <Table.Cell>
                                {dataExtract.dateCreated.format("DD/MM/YY @ h:mma")}
                            </Table.Cell>
                            <Table.Cell>
                                {dataExtract.status}
                            </Table.Cell>
                            <Table.Cell>
                                {dataExtract.status === DataExtractStatus.Completed &&
                                    <Button
                                        content="Download"
                                        as={Link}
                                        href={`/api/dataExtract/${dataExtract.id}/file`}
                                        target="_blank"
                                    />}
                                {dataExtract.status === DataExtractStatus.PartiallyCompleted &&
                                    <>
                                        <Button
                                            content="View Errors"
                                            as={Link}
                                            href={`/api/dataExtract/${dataExtract.id}/errorinfo`}
                                            target="_blank"
                                        />
                                        <Button
                                            content="Download Partial Extract"
                                            alt="Download extract without files which errored"
                                            as={Link}
                                            href={`/api/dataExtract/${dataExtract.id}/file`}
                                            target="_blank"
                                        />
                                    </>}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </Container>
    );
};
